import React, {Component} from "react";
import TripCard from "../../components/TripCard";
import {LayoutHeaderConfig} from "../../components/MainLayout";
import tripsImg from "./trip-image.png";
import {Typography, Divider, Row, Col, Space, Skeleton} from 'antd';
import {bindActionCreators} from "redux";
import InfiniteScroll from 'react-infinite-scroller';
import {fetchPlans} from "../../store/billing/actions";
import {selectPlans} from "../../store/billing/reducer";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {fetchTrips, fetchUserRidesSummary} from "../../store/ride/actions";
import {selectTrips, selectUserRidesSummary} from "../../store/ride/reducer";
import routesConfig from "../../routesConfig";
import momentJalaali from 'moment-jalaali';
import moment from "moment-jalaali";

const { Title, Paragraph, Text } = Typography;

class Trips extends Component{
    constructor(props) {
        super(props);
        this.state = {
            number: -1,
            last: false,
            size: 10,
            totalPages: undefined,
            content: []
        }
        this.now = new Date()
        this.now.setHours(this.now.getHours()+1)
        moment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})
    }

    componentDidMount() {
        this.props.fetchUserRidesSummary()
        this.props.fetchTrips(0, this.state.size);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.trips !==undefined && this.props.trips.number !== undefined){
            if(this.props.trips.number != this.state.number){
                if(this.props.trips.number===0){
                    this.setState(this.props.trips)
                } else {
                    console.log(this.state)
                    console.log(this.props.trips)
                    let cont = this.state.content.concat(this.props.trips.content)
                    this.setState(this.props.trips)
                    this.setState({content: cont})
                }

            }
        }
    }

    render() {
        return <React.Fragment>
            <LayoutHeaderConfig closeable={true} pageTitle="سفرها" menuEnabled={false} extra={[]}/>
            <Row className='px-40'>
                <Col span={24} className="">
                    <Title level={2} className='mb-36 f-30'>تاریخچه سفرها</Title>
                </Col>
            </Row>
            {/*<Space direction="vertical" size={"middle"}>
                {this.props.userRidesSummary === undefined ?
                    <Skeleton/> :
                    <Row>
                        <Col span={12}>
                            <Row justify={'center'}>
                                <Title level={4}>{this.props.userRidesSummary.rideNumber}</Title>
                            </Row>
                            <Row justify={'center'}>
                                <Title level={4}>سفر با رورو</Title>
                            </Row>
                        </Col>
                        <Col span={12}>
                            <Row justify={'center'}>
                                <Title level={4}>{this.props.userRidesSummary.userRidingHours}</Title>
                            </Row>
                            <Row justify={'center'}>
                                <Title level={4}>ساعت با رورو</Title>
                            </Row>
                        </Col>
                    </Row>
                }
                </Space>*/}
            <div className='px-40'>
                {this.props.trips === undefined && this.state.content.length === 0 ?
                    <Skeleton/> :
                    <InfiniteScroll
                        initialLoad={false}
                        loadMore={(page) => this.props.fetchTrips(page, this.state.size)}
                        hasMore={this.props.trips !== undefined && !this.props.trips.last && !this.state.last}
                        threshold={700}
                    >

                        {this.state.content && this.state.content.map((trip, key) =>
                     <TripCard key={key} trip={trip} onClick={() => this.props.history.push(routesConfig.trip+"/"+ trip.id)}/>)
                }

                </InfiniteScroll>
                }
                </div>

        </React.Fragment>
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchTrips,
        fetchUserRidesSummary,
    },
    dispatch);

const mapStateToProps = state => ({
    trips: selectTrips(state),
    userRidesSummary: selectUserRidesSummary(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Trips))